// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__3cAWb","col":"Table_col__2zFiT","fulfillmentStatus":"Table_fulfillmentStatus__1guqs","emailCol":"Table_emailCol__2AZjg"};